<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'setting'"
    class="page"
  >
    <Header
      :setting="{
        title: '帳號設定',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div class="row--evenly mb4 mh4">
      <div class="row--start">
        真實姓名：
      </div>
      <div class="row--end fc--primary">
        {{ composable.member.info.name }}
      </div>
    </div>
    <div class="row--evenly mb4 mh4">
      <div class="row--start">
        出生年月日：
      </div>
      <div class="row--end fc--primary">
        {{ composable.member.info.birthdate }}
      </div>
    </div>
    <div class="row--evenly mh4">
      <div class="row--start">
        證件號碼：
      </div>
      <div class="row--end fc--primary">
        {{ composable.member.info.twid }}
      </div>
    </div>
    <div class="page__form mt8 mb5">
      <input
        v-model="changePasswordForm.password"
        type="password"
        placeholder="新密碼/New Password"
        class="mb5"
      >
      <input
        v-model="changePasswordForm.comfirm"
        type="password"
        placeholder="再次確認密碼/Confirm"
      >
      <div
        :style="{
          visibility: isValidated ? 'hidden' : 'visible'
        }"
        class="align--right fc--primary mr3"
      >
        ＊密碼不符
      </div>
    </div>
    <div
      @click="changePassword"
      class="label label--primary mb4"
    >
      確認修改
    </div>
    <div
      @click="logout"
      class="label label--secondary mb4"
    >
      登出
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toHome="toHome"
  />
</template>

<script>
import { computed, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';

export default {
  setup() {
    const page = ref('setting');
    const changePasswordForm = reactive({
      password: '',
      comfirm: '',
    });
    const router = useRouter();

    const isValidated = computed(() => changePasswordForm.comfirm
      === changePasswordForm.password);

    async function changePassword() {
      try {
        spiderman.form.verify(changePasswordForm);
        if (!isValidated.value) {
          throw Error('確認密碼與新密碼不符。');
        }

        composable.loading.show('更改密碼中，請稍候');

        const response = await api.member.changePassword(
          composable.member,
          changePasswordForm.password,
        );

        composable.modal.popup(response.message);
        clearChangePasswordForm();
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function clearChangePasswordForm() {
      Object.assign(changePasswordForm, {
        password: '',
        comfirm: '',
      });
    }

    async function logout() {
      try {
        composable.loading.show('登出中，請稍候');

        const response = await api.member.logout(composable.member);
        composable.member.updateInfo(response);

        composable.modal.done(response.message);
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function toHome() {
      composable.modal.close();
      router.push({ path: '/home' });
    }

    return {
      page,
      composable,
      changePasswordForm,
      isValidated,
      changePassword,
      logout,
      toHome,
    };
  },
};
</script>
